import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const iconStyles = {
  width: '24px',
  height: '24px',
  color: '#ffffff',
  fill: '#ffffff',
};

export const HomeIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} sx={iconStyles} viewBox="0 0 24 24">
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M13 18h-2v-2h2v2zm2-4H9v6h6v-6zm4-4.7V4h-3v2.6L12 3 2 12h3l7-6.31L19 12h3l-3-2.7z" />
  </SvgIcon>
);

export const TrainingIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} sx={iconStyles} viewBox="0 0 512 512">
    <path d="M64 95.1H0c0 123.8 100.3 224 224 224v128C224 465.6 238.4 480 255.1 480S288 465.6 288 448V320C288 196.3 187.7 95.1 64 95.1zM448 32c-84.25 0-157.4 46.5-195.8 115.3c27.75 30.12 48.25 66.88 59 107.5C424 243.1 512 147.9 512 32H448z" />
  </SvgIcon>
);

export const ToolkitIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} sx={iconStyles} viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15-5-2.18L7 18V5h10v13z" />
  </SvgIcon>
);

export const ReportsIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} sx={iconStyles} viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M13 3a9 9 0 0 0-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0 0 13 21a9 9 0 0 0 0-18zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z" />
  </SvgIcon>
);

export const ExploreIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} sx={iconStyles} viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
  </SvgIcon>
);

export const AdminIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} sx={iconStyles} viewBox="0 0 24 24">
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M17 11c.34 0 .67.04 1 .09V6.27L10.5 3 3 6.27v4.91c0 4.54 3.2 8.79 7.5 9.82.55-.13 1.08-.32 1.6-.55-.69-.98-1.1-2.17-1.1-3.45 0-3.31 2.69-6 6-6z" />
    <path d="M17 13c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 1.38c.62 0 1.12.51 1.12 1.12s-.51 1.12-1.12 1.12-1.12-.51-1.12-1.12.5-1.12 1.12-1.12zm0 5.25c-.94 0-1.75-.48-2.22-1.2.55-.23 1.42-.4 2.22-.4s1.67.17 2.22.4c-.47.72-1.28 1.2-2.22 1.2z" />
  </SvgIcon>
); 